<template>
    <section class="mt-4 mb-4">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="free-delivery">
                        <div class="track-images"></div>
                        <p class="free-text">
                            <span class="blue-text">Free Delivery</span>
                            <br>
                            Free Shipping On All Order
                        </p>
                    </div>
                </div>
                <div class="col-md-4 border-l-r">
                    <div class="free-delivery">
                        <div class="payment-images"></div>
                        <p class="free-text">
                            <span class="blue-text">100% Payment Secure</span>
                            <br>
                            We ensure secure payment with PEV
                        </p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="free-delivery">
                        <div class="return-images"></div>
                        <p class="free-text">
                            <span class="blue-text">Return Policy</span>
                            <br>
                            Support 24 hours a day
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        computed: {},
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
            };
        },
        mounted() {
            //console.log(this.appUrl);
        },
    };
</script>
